import type { EntryTemplate } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCollectionHandler } from "./useCollectionHandler"
import { CollectionKey } from "src/types"

export function useEntryTemplatesHandler() {
  return useCollectionHandler<EntryTemplate>(CollectionKey.EntryTemplate)
}
